import { render, staticRenderFns } from "./relatorioEnvio.vue?vue&type=template&id=2b3af6a1&scoped=true"
import script from "./relatorioEnvio.vue?vue&type=script&lang=js"
export * from "./relatorioEnvio.vue?vue&type=script&lang=js"
import style0 from "./relatorioEnvio.vue?vue&type=style&index=0&id=2b3af6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3af6a1",
  null
  
)

export default component.exports